import { Form, Formik } from "formik";
import TextInput from "../UI/TextInput";
import FormikSubmitButton from "../UI/FormikSubmitButton";
import { ModalDialogFooter } from "../UI/ModalDialog";
import Editor from "../RichTextEditor/Editor";
import { mailValidationSchema } from "../../models/mail";
import TextArea from "../UI/TextArea";
import useMailTemplatesCatalog from "../../hooks/use-mail-templates-catalog";

function MailForm({ onSubmit, initialValues, staticId }) {
  const { catalog } = useMailTemplatesCatalog();
  const availableVariables = staticId
    ? catalog?.find((meta) => meta.static_id === staticId)?.variables
    : undefined;

  return (
    <>
      <Formik
        initialValues={initialValues}
        enableReinitialize={true}
        validationSchema={mailValidationSchema}
        onSubmit={onSubmit}
      >
        {({ values, setFieldValue }) => {
          function setValueHandler(value) {
            setFieldValue("html", value);
          }

          return (
            <Form>
              <TextInput
                type="text"
                name="subject"
                label={"Sujet du mail"}
                mandatory
              />
              <TextArea name={"plain"} />
              <Editor
                defaultValue={values.html}
                onChange={setValueHandler}
                availableVariables={availableVariables}
              />
              <ModalDialogFooter>
                <FormikSubmitButton>Valider</FormikSubmitButton>
              </ModalDialogFooter>
            </Form>
          );
        }}
      </Formik>
    </>
  );
}

export default MailForm;
